import React from 'react';
import PropTypes from 'prop-types';
import * as colors from 'material-ui/styles/colors';
import CheckIcon from 'material-ui/svg-icons/action/done';
import ErrorIcon from 'material-ui/svg-icons/content/clear';

const SqcPower = (props) => {

    const {score, value} = props;

    let color = null,
        icon = null;

    function round(value, precision) {
        const multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    const valueDisplay = round(value, 1).toFixed(1);

    if (score === 'Pass') {
        color = colors.green900;
        icon = (<CheckIcon
            color={color}
            style={{
            width: '15px',
            height: '15px'
        }}/>);
    }

    if (score === 'Fail') {
        color = colors.red900;
        icon = (<ErrorIcon
            color={color}
            style={{
            width: '15px',
            height: '15px'
        }}/>);

    }

    return (
        <span style={{
            color: color
        }}>
            {valueDisplay}
            {icon}
        </span>
    );
};

SqcPower.propTypes = {
    value: PropTypes.number,
    score: PropTypes.string

};
export default SqcPower;



// WEBPACK FOOTER //
// ./src/components/equipment/SqcPower.js